import { Pipe, PipeTransform } from '@angular/core';
import { decimalNumberFormatter } from '../utils/formatters/decimal-number';
/*
 * Format amounts to an abbreviated version
 * 1900000 becomes $1.9M
 * 34000000 becomes $34.0M
 * 9760000000 becomes $9.8B
 * Usage:
 *   value | decimalPlaces
 * Example:
 *   {{ 9760000000 | 1 }}
 *   formats to: $9.8B
 */
@Pipe({ name: 'Illions',
  standalone: false,
})
export class IllionsPipe implements PipeTransform {
  transform(input: number, decimalPlaces: number): string {
    const suffixes = ['k', 'Mn', 'B', 'T', 'Q'];

    if (Number.isNaN(input)) {
      return '';
    }
    if (input < 1000) {
      return `$${input}`;
    }

    const l: number = Math.floor(Math.log(input) / Math.log(1000));
    const num: number = input / Math.pow(1000, l);

    return (
      '$' + decimalNumberFormatter(num, decimalPlaces) + '' + suffixes[l - 1]
    );
  }
}
